// NavigationContext.js
import React, { createContext, useContext, useState } from "react";
import { useLocation } from "react-router-dom";

const NavigationContext = createContext();

export const NavigationProvider = ({ children }) => {
  const [previousLocation, setPreviousLocation] = useState(null);
  const location = useLocation();

  React.useEffect(() => {
    setPreviousLocation(location);
  }, [location]);

  return (
    <NavigationContext.Provider value={{ previousLocation }}>
      {children}
    </NavigationContext.Provider>
  );
};

export const useNavigation = () => useContext(NavigationContext);
